import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Screener from './Screener';
import { Helmet } from "react-helmet";
import ScreenerCriteria from './ScreenerCriteria';

class ScreenerWrap extends Component {
  componentWillMount(){
    console.log('screenwrap query params',this.props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Stock Screener</title>
          <link rel="canonical" href="https://www.vizfm.com/screener" />
          <meta name="description" content="Stock screener for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col>
              <ScreenerCriteria {...this.props}/>
              <Screener {...this.props}/>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ScreenerWrap;
